import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';

import { AppService } from '@api';
import { SistemaService } from '@servicios/Sistema.Service';

import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';

import { Colaborador } from '@modelo/catalogo/Colaborador.model';

@Component(
  {
    selector: 'colaboradormodal',
    templateUrl: './colaborador.template.html',
    styleUrls: ['./colaborador.component.scss']
  })

export class ColaboradorModalComponent {
  @Input() seleccionMultiple: boolean = false;
  @Output() respuesta = new EventEmitter();
  dataTable: Array<any>;

  public entidad: Colaborador;

  public abierto!: boolean;
  public animacion!: string;

  @ViewChild('grid') private grid!: DxDataGridComponent;

  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
    this.entidad = new Colaborador();
    this.dataTable = [];

  }

  Modal() {
    this.animacion = this.sistemaService.animacionAbirModal;
    this.abierto = true;
  }

  CerrarModal() {
    this.LimpiarFiltros();
    this.animacion = this.sistemaService.animacionCerrarModal;

    setTimeout(() => {
      this.abierto = false;
    }, 310);
  }


  LimpiarFiltros() {
    this.entidad = new Colaborador();
    this.dataTable = [];
  }

  Buscar() {
    let data = new Colaborador(this.entidad);
    this.appService.Post("configuracionrh/colaborador/buscar", data).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.dataTable = res.data;
      }
    })
  }

  Guardar() {
    let checked = this.grid.instance.getSelectedRowsData();
    if (this.seleccionMultiple) {
      if (!checked.length) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione uno o más registros");
      }
      this.respuesta.next(checked)
    } else {
      if (checked.length != 1) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione solo un registro");
      }
      this.respuesta.next(checked[0])
    }



  }

}
